import { useHomepageVisibility } from '../utils/homepageVisibility';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from './ui/card';
import { Sparkles } from 'lucide-react';
import { imgVariant } from '../utils/imgUrl';

const SeasonalLandingSectionInner = () => {
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPages();
  }, []);

  const loadPages = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/seasonal-landing-pages/active`
      );

      if (response.ok) {
        const data = await response.json();
        setPages(data);
      }
    } catch (error) {
      console.error('Error loading seasonal pages:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || pages.length === 0) {
    return null; // Don't show section if no pages
  }

  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Sparkles className="h-8 w-8 text-[#D4AF37]" />
            <h2 className="text-4xl font-bold text-gray-800">
              Saisonale Highlights
            </h2>
            <Sparkles className="h-8 w-8 text-[#D4AF37]" />
          </div>
          <p className="text-lg text-gray-600">
            Entdecken Sie unsere speziellen saisonalen Kollektionen
          </p>
        </div>

        {/* Pages Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {pages.map((page) => (
            <Card
              key={page.id}
              className="group cursor-pointer overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              onClick={() => navigate(`/seasonal/${page.id}`)}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                {page.image_url && (
                  <img
                    src={imgVariant(page.image_url, { w: 800 })}
                    alt={page.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex items-end">
                  <div className="p-6 w-full">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      {page.title}
                    </h3>
                    {page.description && (
                      <p className="text-white/90 text-sm line-clamp-2">
                        {page.description}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

const SeasonalLandingSection = () => {
  const visibility = useHomepageVisibility();
  return visibility.show_seasonal_landing ? <SeasonalLandingSectionInner /> : null;
};

export default SeasonalLandingSection;
